class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800), this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    facetWrapper && facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      searchParams !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections(), updateEvent = FacetFiltersForm.startUpdateEvent(searchParams), countContainer = document.getElementById("ProductCount"), countContainerDesktop = document.getElementById("ProductCountDesktop");
    document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach((spinner) => spinner.classList.remove("hidden")), document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"), countContainer && countContainer.classList.add("loading"), countContainerDesktop && countContainerDesktop.classList.add("loading"), sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`, filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent) : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
    }), updateURLHash && FacetFiltersForm.updateURLHash(searchParams);
  }
  static startUpdateEvent(searchParams) {
    var _a;
    const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent && !CollectionUpdateEvent) return;
    const facetsForm = document.querySelector("facet-filters-form"), facetsContainer = document.querySelector(".facets-container"), collectionId = (facetsContainer == null ? void 0 : facetsContainer.dataset.collectionId) || null, collectionHandle = (facetsContainer == null ? void 0 : facetsContainer.dataset.collectionHandle) || "", currentCount = parseInt((_a = document.getElementById("ProductCount")) == null ? void 0 : _a.dataset.productCount) || 0, urlSearchParams = new URLSearchParams(searchParams), isSearchPage = (facetsContainer == null ? void 0 : facetsContainer.dataset.template) === "search", isCollectionPage = (facetsContainer == null ? void 0 : facetsContainer.dataset.template) === "collection", dispatchTarget = facetsForm || document;
    let deferred;
    if (isSearchPage ? (deferred = SearchUpdateEvent.createPromise(), dispatchTarget.dispatchEvent(new SearchUpdateEvent({ search: { query: urlSearchParams.get("q") || "", productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams), sortKey: SearchUpdateEvent.getSortKey(urlSearchParams) }, promise: deferred.promise }))) : isCollectionPage && (deferred = CollectionUpdateEvent.createPromise(), dispatchTarget.dispatchEvent(new CollectionUpdateEvent({ collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount }, productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams), sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams), promise: deferred.promise }))), !!deferred) return { resolve: (filteredCount) => {
      deferred.resolve({ [isSearchPage ? "totalCount" : "productsCount"]: filteredCount });
    }, reject: deferred.reject };
  }
  static renderSectionFromFetch(url, event, updateEvent) {
    fetch(url).then((response) => response.text()).then((html) => {
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }], FacetFiltersForm.renderSection(html, event, updateEvent);
    }).catch((error) => {
      console.error(error), updateEvent == null ? void 0 : updateEvent.reject(error);
    });
  }
  static renderSectionFromCache(filterDataUrl, event, updateEvent) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event, updateEvent);
  }
  static renderSection(html, event, updateEvent) {
    FacetFiltersForm.renderFilters(html, event), FacetFiltersForm.renderProductGridContainer(html), FacetFiltersForm.renderProductCount(html, updateEvent), typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML);
  }
  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML, document.getElementById("ProductGridContainer").querySelectorAll(".scroll-trigger").forEach((element) => {
      element.classList.add("scroll-trigger--cancel");
    });
  }
  static renderProductCount(html, updateEvent) {
    const sourceCount = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount"), count = sourceCount.innerHTML, container = document.getElementById("ProductCount"), containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count, container.dataset.productCount = sourceCount.dataset.productCount || "", container.dataset.totalCount = sourceCount.dataset.totalCount || "", container.classList.remove("loading"), containerDesktop && (containerDesktop.innerHTML = count, containerDesktop.classList.remove("loading")), document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach((spinner) => spinner.classList.add("hidden")), updateEvent == null ? void 0 : updateEvent.resolve(parseInt(sourceCount.dataset.productCount) || 0);
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html"), facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"), facetDetailsElementsFromDom = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id) || currentElement.remove();
    });
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : void 0;
      return jsFilter ? element.id === jsFilter.id : false;
    }, facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element)), countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
    if (facetsToRender.forEach((elementToRender, index) => {
      if (document.getElementById(elementToRender.id)) document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
      }
    }), FacetFiltersForm.renderActiveFacets(parsedHTML), FacetFiltersForm.renderAdditionalElements(parsedHTML), countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter")), FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (!(event.target.getAttribute("type") === "text")) {
          const originatingInputId = event.target.id, matchingInput = originatingInputId ? newFacetDetailsElement.querySelector(`#${CSS.escape(originatingInputId)}`) : null;
          if (matchingInput) matchingInput.focus();
          else {
            const fallbackSelector = newFacetDetailsElement.classList.contains("mobile-facets__details") ? ".mobile-facets__close-button" : ".facets__summary", fallbackElement = newFacetDetailsElement.querySelector(fallbackSelector);
            fallbackElement && fallbackElement.focus();
          }
        }
      }
    }
  }
  static renderActiveFacets(html) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      activeFacetsElement && (document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML);
    }), FacetFiltersForm.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((selector) => {
      html.querySelector(selector) && (document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML);
    }), document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
  }
  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary"), sourceSummary = source.querySelector(".facets__summary");
    sourceSummary && targetSummary && (targetSummary.outerHTML = sourceSummary.outerHTML);
    const targetHeaderElement = target.querySelector(".facets__header"), sourceHeaderElement = source.querySelector(".facets__header");
    sourceHeaderElement && targetHeaderElement && (targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML);
    const targetWrapElement = target.querySelector(".facets-wrap"), sourceWrapElement = source.querySelector(".facets-wrap");
    sourceWrapElement && targetWrapElement && (target.querySelector("show-more-button .label-show-more.hidden") && sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach((hiddenItem) => hiddenItem.classList.replace("hidden", "show-more-item")), targetWrapElement.outerHTML = sourceWrapElement.outerHTML);
  }
  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list"), sourceFacetsList = source.querySelector(".mobile-facets__list");
    sourceFacetsList && targetFacetsList && (targetFacetsList.outerHTML = sourceFacetsList.outerHTML);
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }
  static getSections() {
    return [{ section: document.getElementById("product-grid").dataset.id }];
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [], isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";
      sortFilterForms.forEach((form) => {
        isMobile ? form.id === "FacetFiltersFormMobile" && forms.push(this.createSearchParams(form)) : (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") && forms.push(this.createSearchParams(form));
      }), this.onSubmitForm(forms.join("&"), event);
    }
  }
  onActiveFilterClick(event) {
    event.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}
FacetFiltersForm.filterData = [], FacetFiltersForm.searchParamsInitial = window.location.search.slice(1), FacetFiltersForm.searchParamsPrev = window.location.search.slice(1), customElements.define("facet-filters-form", FacetFiltersForm), FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super(), this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this)), element.addEventListener("keydown", this.onKeyDown.bind(this));
    }), this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget), this.setMinAndMaxValues();
  }
  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    event.key.match(pattern) || event.preventDefault();
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input"), minInput = inputs[0], maxInput = inputs[1];
    maxInput.value && minInput.setAttribute("data-max", maxInput.value), minInput.value && maxInput.setAttribute("data-min", minInput.value), minInput.value === "" && maxInput.setAttribute("data-min", 0), maxInput.value === "" && minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }
  adjustToValidValues(input) {
    const value = Number(input.value), min = Number(input.getAttribute("data-min")), max = Number(input.getAttribute("data-max"));
    value < min && (input.value = min), value > max && (input.value = max);
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button"), facetLink.addEventListener("click", this.closeFilter.bind(this)), facetLink.addEventListener("keyup", (event) => {
      event.preventDefault(), event.code.toUpperCase() === "SPACE" && this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault(), (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(event);
  }
}
customElements.define("facet-remove", FacetRemove);
